/**
 * How long a warm session waits for its first prompt; showing the composer again extends it.
 * It has a module of its own, so the pull request page, which hands its chat to its next load
 * only while the chat's warm session lasts (`page-chat-handoff.ts`), reads it in the browser
 * without the server's warm-session module.
 */
export const WARM_SESSION_TTL_MS = 5 * 60 * 1000;
